import styled from "@emotion/styled";
import {Typography} from "@mui/material";

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "22px",
  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#000000"
}));

export default StyledTypography;